import { orderXClient } from '@/service/client'
import type { TokenUnlockHistoryParams } from '@/service/tokenomist.types'
import type { DataPayload, GetTokenEmissionRequest } from '@/types/generated/public_api'
import type { ErrorResponse } from '@/types/service'

export async function fetchTokenUnlocks(payload: TokenUnlockHistoryParams, signal?: AbortSignal) {
  try {
    const { data } = await orderXClient.post<DataPayload>(
      '/api',
      { getTokenUnlocks: payload },
      { headers: { 'X-Decode-Key': 'datapayload' }, signal }
    )
    const eventList = data.tokenUnlockEventList
    if (!eventList) {
      return Promise.reject({
        status: 400,
        message: 'Failed to fetch token unlocks',
      } satisfies ErrorResponse)
    }
    return eventList
  } catch (e) {
    return Promise.reject(e as ErrorResponse)
  }
}

export async function fetchTokenEmission(payload: GetTokenEmissionRequest, signal?: AbortSignal) {
  try {
    const { data } = await orderXClient.post<DataPayload>(
      '/api',
      { getTokenEmission: payload },
      { headers: { 'X-Decode-Key': 'datapayload' }, signal }
    )
    // A missing oneof arm is the only failure. An empty `points` array is a
    // legitimate response — coverage is partial by design, and a token with no
    // vesting schedule left to model returns an empty series, not an error.
    const series = data.tokenEmissionSeries
    if (!series) {
      return Promise.reject({
        status: 400,
        message: 'Failed to fetch token emission series',
      } satisfies ErrorResponse)
    }
    return series
  } catch (e) {
    return Promise.reject(e as ErrorResponse)
  }
}
